import React from "react";
import ModifyCancelForm from "./ModifyCancelForm";

export default function Index(props) {
  return <ModifyCancelForm {...props} />;
}
